import { useObtainNotificationCountQuery } from '@/types/generated/graphql';

export function useNotificationCount() {
  const { data } = useObtainNotificationCountQuery();

  return {
    count: data?.obtainNotificationCount?.data?.count ?? 0,
  };
}
